import { render, staticRenderFns } from "./myMessageBox.vue?vue&type=template&id=3c32b286&scoped=true&"
import script from "./myMessageBox.vue?vue&type=script&lang=js&"
export * from "./myMessageBox.vue?vue&type=script&lang=js&"
import style0 from "./myMessageBox.vue?vue&type=style&index=0&id=3c32b286&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c32b286",
  null
  
)

export default component.exports